import script from "./AppButtonGroup.vue?vue&type=script&lang=js"
export * from "./AppButtonGroup.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__